module.exports = __webpack_public_path__ + "img/icon_truck.d29424c3.png";